export default () => ({
  handler: 'relativeUrl',
  data: ({ walletCpbtId }) => `/offer/wallets/${walletCpbtId || ''}`,
});
